import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const AtomIcon = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="-2 -2 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.1163 13.3582C14.8456 13.6642 14.5615 13.9665 14.2645 14.2635C9.96873 18.5593 4.58683 20.1422 2.24368 17.7991C0.637277 16.1926 0.876175 13.158 2.56944 10.0242M4.89065 6.72526C5.17236 6.40495 5.4687 6.08875 5.77921 5.77824C10.075 1.48247 15.4569 -0.100442 17.8 2.2427C19.4075 3.85021 19.1672 6.88795 17.4708 10.024M14.2645 5.77824C18.5603 10.074 20.1432 15.4559 17.8 17.7991C15.4569 20.1422 10.075 18.5593 5.77921 14.2635C1.48345 9.96775 -0.0994656 4.58585 2.24368 2.2427C4.58683 -0.100442 9.96873 1.48247 14.2645 5.77824ZM11.001 9.99999C11.001 10.5523 10.5533 11 10.001 11C9.44875 11 9.00104 10.5523 9.00104 9.99999C9.00104 9.44771 9.44875 8.99999 10.001 8.99999C10.5533 8.99999 11.001 9.44771 11.001 9.99999Z"
                stroke="#0070C8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
